<template>
  <div class="col-12">
    <div class="row mt-3">
      <div class="col-12">
        <IconCard :kpis="this.kpis" :infoTitle="this.territoryName" :periodInfo="$t('dashboard.provenance.caption')" />
      </div>
    </div>
    <b-row class="mt-1">
      <b-col class="col-lg-6 col-12 mt-3" v-if="this.topFiveCountries">
        <TableCard :title="this.topFiveCountries.title" :table="this.topFiveCountriesData"
          :header="this.topFiveCountries.fields"/>
      </b-col>
      <b-col class="col-lg-6 col-12 mt-3">
        <b-card header-bg-variant="custom" no-body>
          <template #header>
            <h4 class="text-white">{{ $t('general.demographicData') }}</h4>
          </template>
          <b-card-body>
            <b-row>
              <p class="text-muted small col-12">{{ $t('general.demographicDataRemark') }}</p>
            </b-row>
            <b-row>
              <b-col class="col-12">
                <b-row class="text-center">
                  <h5 class="col-12">
                    {{ $t("general.genderDistribution") }}
                  </h5>
                </b-row>
                <b-row class="mt-1 text-center">
                  <b-col class="col-lg-6 col-12 mt-3">
                    <b-row>
                      <b-col class="col-6">
                        <font-awesome-icon :icon="['fas', 'venus']" size="2x" />
                      </b-col>
                      <b-col class="col-6">
                        <h6>
                          {{ this.female_percent }}%
                        </h6>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col class="col-lg-6 col-12 mt-3">
                    <b-row>
                      <b-col class="col-6">
                        <font-awesome-icon :icon="['fas', 'mars']" size="2x" />
                      </b-col>
                      <b-col class="col-6">
                        <h6>{{ this.male_percent }}%</h6>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
              <b-col class="col-12 mt-3">
                <b-row class="text-center">
                  <h5 class="col-12">
                    {{ $t("general.ageDistribution") }}
                  </h5>
                </b-row>
                <b-row class="mt-2" v-if="this.ageGroups.series[0].data">
                  <b-col class="col-12">
                    <apexchart height="250" type="bar" :options="this.ageGroups.chartOptions"
                      :series="this.ageGroups.series">
                    </apexchart>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="">
      <b-col class="col-lg-6 col-12 mt-3">
        <ChartCard v-if="this.hourlyVisitors.series[0].data" :title="this.hourlyVisitors.title"
          :options="this.hourlyVisitors.chartOptions" :data="this.hourlyVisitors.series"
          :chartType="this.hourlyVisitors.type" />
      </b-col>
      <b-col class="col-lg-6 col-12 mt-3">
        <WeekdayChartCard v-if="this.dwellTimes.data" :title="$t('indicators.dwellTimes')"
          :options="this.dwellTimes.options" :data="this.dwellTimes.data" :chartType="this.dwellTimes.type" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ChartCard from "@/components/dashboard/ChartCard";
import WeekdayChartCard from "@/components/dashboard/WeekdayChartCard";
import TableCard from "@/components/dashboard/TableCard";
import IconCard from "@/components/dashboard/IconCard.vue";

export default {
  components: {
    ChartCard,
    WeekdayChartCard,
    TableCard,
    IconCard
  },
  props: {
    territoryName:{
      type: String,
      required: true
    },
    topFiveCountries: {
      type: Object,
      required: true
    },
    topFiveCountriesData: {
      type: Array,
      required: true
    },
    hourlyVisitors: {
      type: Object,
      required: true
    },
    dwellTimes: {
      type: Object,
      required: true
    },
    ageGroups: {
      type: Object,
      required: true
    },
    male_percent: {
      type: Number,
      required: true
    },
    female_percent: {
      type: Number,
      required: true
    },
    kpis: {
      type: Object,
      required: true
    }
  }
}
</script>

<style></style>